/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { DiyActivity, Steps, YouTubeBox } from './components';
import { IMonsterJamCarWashViewProps } from './monster-jam-car-wash';

export default (props: IMonsterJamCarWashViewProps) => {
  return (
    <React.Fragment>
      <DiyActivity />
      <div className='row'>
        <div className='col-lg-12 col-md-12'>
          <div className='diy-page-container'>
            <Steps />
            <YouTubeBox />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
